import { render, staticRenderFns } from "./ShopAddEditModal.vue?vue&type=template&id=4c5839cb&"
import script from "./ShopAddEditModal.vue?vue&type=script&lang=js&"
export * from "./ShopAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports